__turbopack_context__.v({
  "actions": "hJMtYG_actions",
  "article": "hJMtYG_article",
  "channelLink": "hJMtYG_channelLink",
  "copyButton": "hJMtYG_copyButton",
  "copyButtonText": "hJMtYG_copyButtonText",
  "heading": "hJMtYG_heading",
  "socialShare": "hJMtYG_socialShare",
});
